/**
 * This file is part of ONP.
 *
 * Copyright (c) 2013 Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Andrey Tkachenko <andrey.tkachenko@opensoftdev.ru>
 */

define(['backbone', 'assets/js/modules/Operation'], function(backbone, Operation) {
    var OperationProcessor = backbone.Collection.extend({
        initialize: function(items, options) {
            options = options || {};

            var self = this;
            this._name = options.name;
            this._lastResult = null;
            this._callbacks = [];
            this._cursor = 0;
            this._executionContext = {};

            var context = {
                terminate: function() {
                    self.terminate();
                },

                start: function() {
                    self.start(this.getObject());
                },

                stop: function() {
                    self.stop();
                }
            };

            if (options.operation) {
                this._operation = options.operation;
                this._operation.setContext(context);
            } else {
                this._operation = new Operation(
                    {
                        name: this._name
                    },
                    context,
                    false
                );
            }
        },

        add: function(item, callback) {
            var self = this;
            this._operation.setProgress(self._calculateOverAllProgress());

            if (!item instanceof Operation) {
                throw new TypeError('Operation expected!');
            }

            this.listenTo(item, Operation.EVENT_PROGRESS, function() {
                self._operation.setProgress(self._calculateOverAllProgress());
            });

            this.listenTo(item, Operation.EVENT_FINISHED, function(value) {
                //if (self._operation.isInProgress()) {
                self._updateOneFinished(item, value);
                //}
            });

            this._callbacks.push(callback);

            backbone.Collection.prototype.add.call(this, item);
        },

        drop: function() {
            var op = this.pop();
            this._callbacks.pop();
            this.stopListening(op);
        },

        next: function() {
            if (!this._currentOperation) {
                this._currentOperation = this.at(this._cursor);
                this._cursor++;

                if (!this._currentOperation) {
                    this._operation.setFinished(Operation.SUCCESS, this._lastResult);
                    this.reset();
                } else {
                    this._operation.set('message', this._currentOperation.get('name'));
                    this._currentOperation.setObject(this._lastResult);
                    this._currentOperation.start(this._executionContext);
                }
            } else {
                this._currentOperation.resume();
            }
        },

        start: function(init, executionContext) {
            var self = this;
            this._lastResult = init;
            this._executionContext = executionContext;
            this._operation.setStarted();
            this._cursor = 0;
            this._currentOperation = null;

            setTimeout(function() {
                self.next();
            });
        },

        stop: function() {
            this._currentOperation.stop();
            this._operation.setStopped();
        },

        terminate: function() {
            this._currentOperation.terminate();
            this._operation.setFinished(Operation.TERMINATED);
        },

        getOperation: function() {
            return this._operation;
        },

        reset: function() {
            this._currentOperation = null;
            this._cursor = 0;
        },

        _calculateOverAllProgress: function() {
            var itemPortion = 1 / this.length;

            return this.reduce(function(acc, item) {
                return (acc += itemPortion * item.getProgress());
            }, 0);
        },

        _updateOneFinished: function(operation, value) {
            this._currentOperation = null;

            if (operation.getStatus() == Operation.ERROR) {
                return this._operation.setFinished(Operation.ERROR, operation.toString());
            }

            if (operation.getStatus() == Operation.TERMINATED) {
                return this._operation.setFinished(Operation.TERMINATED, operation.toString());
            }

            var index = this.indexOf(operation);

            if (this._callbacks[index]) {
                value = this._callbacks[index].apply(this, [value]);
            }

            this._lastResult = value;
            this._operation.setProgress(this._calculateOverAllProgress());

            this.next();
        }
    });

    return OperationProcessor;
});
